<template>
    <div class="d-flex" :class="col">
        <loading :active.sync="loader" :is-full-page="true" color="#28a745" loader="bars" />
        <div class="card flex-fill border border-warning riseup-mp">
            <center><img class="card-img-top mt-2" :src="program.logo_path" style="max-width:200px;"></center>
            <div class="card-body">
                <p class="text-justify">{{program.menu_desc}}</p>
            </div>
            <div class="card-footer bg-none mx-auto">
                <button type="button" class="btn btn-success btn-lg px-5" @click="getMenuErf">APPLY</button>
            </div>
        </div>

        <div class="modal fade" id="modalDocReq" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">Documentary Requirements</h5>
                    </div>
                    <div class="modal-body">
                        <div class="card-body mt-n3">
                            <ul>
                                <li>One (1) valid identification card (ID) of the borrower (please see Annex A for the list of valid IDs);</li>
                                <li>Barangay Certification/Permit of the previous and current year or Valid/ Unexpired Barangay Micro Business Enterprise (BMBE) for loans up to PhP100.0 thousand</li>
                                <li>Latest General Information Sheet (for corporations) or Articles of Partnership (for partnerships)</li>
                                <li>Proof of bank account or electronic money account (must be under the name of the sole proprietor, sole proprietorship, partnership, or corporation)</li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="nextApply()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>
        </div>



        <div class="modal fade" id="modalERF" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">Which Enterprise Rehabilitation Financing Program are you applying for?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row px-md-4">
                            <div class="col-lg-4 d-flex" v-for="(item, index) in menu" :key="index">
                                <div class="card flex-fill bg-gray">
                                    <div class="card-body">
                                        <h4 class="bold text-center bl">{{ item.calamity }}</h4>
                                        <p class="text-justify bl">{{ item.description }}</p>
                                    </div>
                                    <div class="card-footer bg-none mx-auto">
                                        <button type="button" class="btn btn-success btn-lg px-5" @click="applyCarina(item.calamity_tag)">APPLY</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            col: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                loader: false,
                menu: [],
                program: {
                    id: '',
                    loan_bus_code: '',
                    program_name: '',
                    program_description: '',
                    menu_desc: '',
                    logo_path: '',
                },
            }
        },

        created() {
            this.getMenu();
        },
        methods: {
            getMenu() {
                this.loader = true;
                axios.get('/api/sblaf-menu-erf')
                    .then(res => {
                        let data = res.data;
                        this.menu = data.erf;
                        this.program = data.program;
                        this.loader = false;
                    }).catch(err => {
                        this.loader = false;
                    })
            },


            getMenuErf() {
                $('#modalERF').modal('show');
            },

            nextApply() {
                $('#modalDocReq').modal('hide');
                this.$router.push('/apply-loan/erf');
            },
            swalIneligible(message) {
                Swal.fire({
                    icon: 'warning',
                    html: `<p class="mx-n2 text-justify">${message}</p>`,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowOutsideClick: false,

                })
            },

            applyCarina(calamity_tag) {
                //check on backend borrower name; use to validate the request as autheticated user
                this.loader = true;
                axios.post('/api/erf-qualification', {
                        calamity_tag: calamity_tag
                    })
                    .then(res => {
                        this.loader = false;
                        let data = res.data;
                        let ineligible = data.ineligible ?? false;
                        if (ineligible) {
                            this.swalIneligible(data.message);
                        } else {
                            $('#modalERF').modal('hide');
                            $('#modalDocReq').modal('show');
                        }

                    }).catch(err => {
                        this.loader = false;
                    })
            },
        },
        computed: {},
        mounted() {}
    }
</script>
<style scoped>
    .btn-fit {
        border-radius: 0 !important;
        width: 100%;
    }

    .alert-danger2 {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
    }

    .riseup-mp {
        border-color: #fe9900 !important;
        border-width: 7px !important
    }

    .riseup-turismo {
        border-color: #263d81 !important;
        border-width: 7px !important
    }

    .riseup-tindahan {
        /* border-color: #78a236 !important; */
        border-width: 7px !important
    }

    .bg-none {
        background-color: transparent !important;
    }

    .bl {
        color: black;
    }

    .bg-gray {
        background-color: #f3f3f3 !important;
    }

    .bg-gray2 {
        background-color: #E5E5E5 !important;
    }
</style>